import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Divider, Grid } from "@mui/material";

import { profitAnalysis } from "../../../utils/linkSheet";
import openNewTab from "../../../utils/openNewTab";

import { AutomaticManagement } from "./AutomaticManagement";
import { ManualManagement } from "./ManualManagement";

export const CogsPanel = () => {
  const { state } = useLocation();
  useEffect(() => {
    const el = document.getElementById(state?.targetId);
    if (el) {
      window.scrollTo({
        behavior: "smooth",
        top:
          el.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top +
          750,
      });
    }
  }, [state?.targetId]);
  return (
    <IgPaper>
      <Grid
        container
        direction={"column"}
        rowSpacing={2}
        id={"cogs-management"}
      >
        <Grid item>
          <IgTypography variant="h6">
            Manage COGS With Intelligems{" "}
            <IgTypography
              onClick={() => {
                openNewTab(profitAnalysis, "Profit Analytics");
              }}
              igStyle={"link"}
            >
              Learn more here.
            </IgTypography>
          </IgTypography>
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <AutomaticManagement />
        <Grid item>
          <Divider />
        </Grid>
        <ManualManagement />
      </Grid>
    </IgPaper>
  );
};
